import { Link, useLocation } from 'react-router';
import { StatusMessage } from '../../app/status-content';

/**
 * Catch-all 404. nginx already answers unknown paths with HTTP 404 (docker/nginx/spa-routes.map),
 * so crawlers see the right status; this is what people see.
 */
export default function NotFoundPage() {
  const { pathname } = useLocation();
  return (
    <StatusMessage
      code="Error 404"
      actions={
        <>
          <Link to="/">Go to My view</Link>
          <Link to="/issues">View issues</Link>
        </>
      }
    >
      <p>
        There is no page at <code className="break-all font-mono text-sm">{pathname}</code>. It may
        have been moved, or the address may be mistyped.
      </p>
    </StatusMessage>
  );
}
